import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    accountDomains: []
  },
  mutations: {
    SET_ACCOUNT_DOMAINS (store, items) {
      store.accounts.selectIds = items
    }
  },
  getters: {
    getAccountDomains: (store, getters) => {
      return store.accounts.accountDomains
    }
  },
  actions: {
    /*
    selectAccountDomains
    */
    selectAccountDomains ({commit, dispatch, getters, state}, filters) {
      return dispatch('getAccountDomains', filters).then((response) => {
        commit('SET_ACCOUNT_DOMAINS', response)
        return response
      })
    },
    /*
    getAccountDomains
    */
    getAccountDomains ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${id}/account-domains`)
      .then((response) => {
        return response.data
      })
    },
    /*
    updateAccountDomains
    */
    updateAccountDomains ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${data._id}/account-domains`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accountDomains.js